module.exports = __webpack_public_path__ + "img/company_company-number.71892b60.svg";